import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';
import { LanguageContext } from '../contexts/LanguageContext';
import iconGithub from '../img/icon/github-icon.svg';
import iconLinkedin from '../img/icon/linkedin-icon.svg';

const Footer: React.FC = () => {
    const { language } = useContext(LanguageContext)!;

    const translations = {
        en: {
            copyright: "© 2024 Antoine Wurtz. All rights reserved.",
            legal: "Legal notice / General terms and conditions"
        },
        fr: {
            copyright: "© 2024 Antoine Wurtz. Tous droits réservés.",
            legal: "Mentions légales / Conditions générales de vente"
        },
    };

    return (
        <footer className="footer">
            <div className="social-icons">
                <a href="https://github.com/AntoineWtz" target="_blank" rel="noopener noreferrer">
                    <img src={iconGithub} alt="GitHub" />
                </a>
                <a href="https://www.linkedin.com/in/antoine-wurtz/" target="_blank" rel="noopener noreferrer">
                    <img src={iconLinkedin} alt="LinkedIn" />
                </a>
            </div>
            <div className='legal-footer'>
                <Link to="/legal">{translations[language].legal}</Link>
            </div>
            <p>{translations[language].copyright}</p>
        </footer>
    );
}

export default Footer;
